import { render, staticRenderFns } from "./RecordRating.vue?vue&type=template&id=1bc5cf24&"
import script from "./RecordRating.vue?vue&type=script&lang=js&"
export * from "./RecordRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports